import React from "react";
import { Mic, AudioLines, Video, Drone, Speaker, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Videotuotanto",
  description: "Esittelyvideot, matkailusisällöt, tapahtumat, haastattelut ja dokumentaarinen videotuotanto.\nTuomme esiin paikkojen, ihmisten ja yhteisöjen tarinoita videon keinoin.",
  icon: Mic
}, {
  title: "Ääni- ja musiikkituotanto",
  description: "Äänitys, miksaus, masterointi, äänisuunnittelu sekä tilaussävellykset.\nLuomme ääntä, joka tukee viestiä ja vahvistaa tunnelmaa.",
  icon: AudioLines
}, {
  title: "Podcast-tuotanto",
  description: "Monikamerapodcastit, ääni- ja videopodcastit sekä julkaisuvalmiit tuotannot.\nKokonaisvaltainen palvelu suunnittelusta kuvaukseen, editointiin ja julkaisuun.",
  icon: Video
}, {
  title: "Dronekuvaus",
  description: "Ilmakuvaukset matkailuun, markkinointiin ja luontokohteisiin.\nTarjoamme uusia näkökulmia paikkoihin, ympäristöihin ja tarinoihin.",
  icon: Drone
}, {
  title: "Äänentoistopalvelut",
  description: "Tapahtumien, konserttien ja puhetilaisuuksien äänentoisto.\nLaadukkaat äänentoistoratkaisut sisä- ja ulkotapahtumiin sekä sähköttömiin kohteisiin.",
  icon: Speaker
}, {
  title: "Livetuotannot",
  description: "Esiintymiset, tapahtumat ja tekninen toteutus samasta paikasta.\nTarjoamme tapahtumiin äänentoiston, esiintyjät sekä tarvittaessa kuvaus- ja tallennuspalvelut yhtenä kokonaisuutena.",
  icon: Zap
}];
export default function PalvelummeOrganisaatioille() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="palvelut" ref={ref} className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="transition-opacity duration-700 !opacity-[1]">
          <div className="mb-16 max-w-2xl">
            <h2 className="font-serif text-3xl mb-6 !text-[rgba(24,46,78,1)] md:text-4xl">Tuotantopalvelumme</h2>
            <p className="text-muted-foreground text-lg font-sans leading-relaxed">Videon, äänen ja musiikin keinoin rakennettua sisältöä kunnille, yrityksille, yhteisöille ja tapahtumille.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, i) => <div key={i} data-index={i} className="h-full">
                <Card className={cn("h-full border border-border shadow-none rounded-lg transition-all duration-400 ease-in-out group cursor-default", "hover:bg-primary hover:border-primary hover:text-primary-foreground bg-card")}>
                  <CardHeader className="pt-8 px-8 pb-4">
                    <div className="mb-6">
                      {i === 0 ? <Video strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" /> : i === 1 ? <AudioLines strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" /> : i === 2 ? <Video strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" /> : i === 3 ? <Drone strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" /> : i === 4 ? <Speaker strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" /> : <Zap strokeWidth={1} className="w-8 h-8 text-foreground transition-colors duration-400 group-hover:text-primary-foreground" />}
                    </div>
                    <CardTitle className="font-serif text-2xl font-medium transition-colors duration-400 group-hover:text-primary-foreground !text-[rgba(24,46,78,1)]">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-8">
                    <CardDescription className="font-sans text-base leading-relaxed text-muted-foreground transition-colors duration-400 group-hover:text-primary-foreground/90">
                      {service.description.includes('\n') ? <>
                          <p className="font-bold mb-2 text-foreground transition-colors duration-400 group-hover:text-primary-foreground">
                            {service.description.split('\n')[0]}
                          </p>
                          <p>
                            {service.description.split('\n')[1]}
                          </p>
                        </> : service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}